const DaysBetweenDates = ({ startDate, endDate }) => {
  return Math.abs(Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)));
};

export default DaysBetweenDates;
